import React from "react";
import "./Message.css";

interface MessageProps {
  title: string;
  description: string;
}

interface MessageProps {
  title: string;
  description: string;
  type: "success" | "info" | "warn";
}

const Message: React.FC<MessageProps> = ({ title, description, type }) => {
  return (
    <div className={`alert-${type}`}>
      <div className="alert-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <div className="alert-content">
        <span className="alert-title">{title}</span>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Message;
